import React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'

const Pagination = ({ page, totalPages, total, limit, onPageChange, onLimitChange }) => {
  const pageSizes = [20, 50, 100, 500, 1000]
  const start = (page - 1) * limit + 1
  const end = Math.min(page * limit, total)

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-border">
      <div className="flex items-center space-x-4">
        <span className="text-text-muted text-sm">
          {total > 0 ? `${start}–${end} of ${total.toLocaleString()}` : 'No results'}
        </span>
        <div className="flex items-center space-x-1.5">
          <label className="text-text-muted text-xs">Show:</label>
          <select
            value={limit}
            onChange={(e) => onLimitChange(parseInt(e.target.value))}
            className="text-xs border border-border rounded px-1.5 py-1 bg-white text-text-primary focus:outline-none focus:ring-1 focus:ring-accent"
          >
            {pageSizes.map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
      </div>
      {totalPages > 1 && (
        <div className="flex items-center space-x-1">
          <button
            onClick={() => onPageChange(1)}
            disabled={page <= 1}
            className="btn btn-secondary text-xs px-2 py-1 disabled:opacity-30"
          >
            First
          </button>
          <button
            onClick={() => onPageChange(page - 1)}
            disabled={page <= 1}
            className="btn btn-secondary text-xs px-2 py-1 disabled:opacity-30"
          >
            <ChevronLeft size={14} />
          </button>
          <span className="text-text-secondary text-sm px-2 font-medium">
            {page} / {totalPages}
          </span>
          <button
            onClick={() => onPageChange(page + 1)}
            disabled={page >= totalPages}
            className="btn btn-secondary text-xs px-2 py-1 disabled:opacity-30"
          >
            <ChevronRight size={14} />
          </button>
          <button
            onClick={() => onPageChange(totalPages)}
            disabled={page >= totalPages}
            className="btn btn-secondary text-xs px-2 py-1 disabled:opacity-30"
          >
            Last
          </button>
        </div>
      )}
    </div>
  )
}

export default Pagination
